import { customFetch } from "../helpers/customFetch";
import { URL, getConfig } from "../helpers/helpers";
export const getProfiles = async () => {
    try {
        const configs = getConfig('GET');
        const response = await customFetch(`${URL}profiles/`, configs)
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        console.log(e);
    }
}